import * as React from "react";
import clx from "clsx";
import Box from "../box";
import Text from "../text";
import * as styles from "./timeline.css";
import type { TimelineProps } from "./timeline.types";

function Timeline(props: TimelineProps) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="$6"
      attributes={{
        "data-testid": "timeline",
      }}
      className={styles.timeline}
    >
      {props.events?.map((event, index) => (
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-start"
          alignSelf={index % 2 === 0 ? "flex-start" : "flex-end"}
          attributes={{
            "data-testid": "event-item",
          }}
          className={clx(event.className, styles.eventItem)}
        >
          <Box
            p="$8"
            backgroundColor="$cardBg"
            borderColor="$divider"
            borderStyle="solid"
            borderWidth="1px"
            borderRadius="$md"
            boxShadow="$sm"
            attributes={{
              "data-testid": "event-content",
            }}
            className={clx(
              styles.eventContent,
              index % 2 === 0
                ? styles.eventContentArrowRight
                : styles.eventContentArrowLeft,
              index % 2 === 0
                ? styles.eventContentRight
                : styles.eventContentLeft
            )}
          >
            {!event.customContent ? (
              <>
                <Text
                  color="$textSecondary"
                  fontWeight="$normal"
                  fontSize="$sm"
                  attributes={{
                    paddingBottom: "$4",
                  }}
                >
                  {event.timestamp}
                </Text>
                <Text color="$text" fontWeight="$semibold" fontSize="$md">
                  {event.title}
                </Text>
                {event.description ? (
                  <Text color="$text" fontWeight="$normal" fontSize="$sm">
                    {event.description}
                  </Text>
                ) : null}
              </>
            ) : null}
            {event.customContent ? <div>{event.customContent}</div> : null}
            <div
              data-direction={index % 2 === 0 ? "right" : "left"}
              className={styles.eventCircle}
            />
            <div
              data-direction={index % 2 === 0 ? "right" : "left"}
              data-is-last={index === props.events.length - 1}
              className={styles.eventBar}
            />
          </Box>
        </Box>
      ))}
    </Box>
  );
}

export default Timeline;
